import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { MasterParamTable } from "@/features/master-param/MasterParamTable";

export function MasterParamIndex() {
  return (
    <>
      <Breadcrumbs />
      <H2>Master Param List</H2>
      <MasterParamTable />
    </>
  );
}
